import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {CommonServiceService} from '../../../pages/services/common-service.service';
import * as L from 'leaflet';
import { TileLayerOptions } from 'leaflet';
export interface INewTileLayerOptions extends TileLayerOptions {

  id?: string;

}
@Component({
  selector: 'app-leaflet-map',
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.css']
})

export class LeafletMapComponent implements OnInit, OnChanges {
  userData = JSON.parse(sessionStorage.getItem('userdata') || '{}');

  constructor(private commonService: CommonServiceService) { }
  countryAllData: any = [];
  stateBoundaries: any;
  HEATMAP: any;
  geoJson: any;

   ngOnInit(): void {
     setTimeout(() => {
      this.getCountryData();
     }, 100);


  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  getCountryData(): void {
    const countryId = this.userData?.country_id;
    this.commonService.countryData(countryId).subscribe((res: any) => {
      this.countryAllData = res.data;
      this.mapData();

    });
  }

  mapData(): void {
    this.commonService.getStatesGeoJson().subscribe((res: any) => {
      this.stateBoundaries = res;
      this.makeMap(this.stateBoundaries);
    });


  }

  makeMap(statesArr: any, stateName = '', stateCode = '' ): void {

    const mapContainerId = `mapContainer`;
    let heatmap: any = null;
    const statesList = statesArr;
    const mapContainer = document.getElementById(mapContainerId);
    if (!mapContainer) {
      return;
    }
    mapContainer.outerHTML = `<div id='mapContainer' class="bg-white" style="height:350px"></div>`;
    const newMapContainer = document.getElementById(mapContainerId);
    if (!newMapContainer) {
      return;
    }
    newMapContainer.innerHTML = '';
    this.geoJson = this.stateBoundaries;
    heatmap = L.map(mapContainerId, {
        attributionControl: false,
        zoomControl: false,
        zoomSnap: 1.5,
        minZoom: 1,
        maxZoom: 2,
        doubleClickZoom: false,
        closePopupOnClick: false,
        trackResize: false,
        touchZoom: false,
        scrollWheelZoom: false
      }).setView([4.8, 20], 4);
    L.control.zoom({
        position: 'bottomleft'
    }).addTo(heatmap);
    L.tileLayer(
        'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiYXNlZW0zMTIiLCJhIjoiY2phdzIzcW55NXQzbDJxbnFtYXl2eXNnYiJ9.z8_v4MmPVgVFr1V42xEyqA',
        {
          id: 'mapbox.light',
        } as INewTileLayerOptions
      ).addTo(heatmap);
    const stateLayer = L.geoJSON(this.geoJson)
        .setStyle({
          weight: 0,
          fill: true,
          fillOpacity: 0.9,
          fillColor: 'rgb(236, 236, 236)',
          color: '#485058',
        })
        .addTo(heatmap);
    const countryList = this.countryAllData.map((ele: any) => {
           return ele?.name;
        });
    const object: any = {Kenya : 23, Ethiopia: 34, Vietnam: 56};
    heatmap.eachLayer((layer: any) => {

             if (layer.feature){
              const count = object[layer.feature.properties.name] ? object[layer.feature.properties.name] : 0;
              if (countryList.includes(layer.feature.properties.name) ||
                (layer.feature.properties.hasOwnProperty('gu_a3') && countryList.includes(layer.feature.properties.gu_a3))) {
                layer.setStyle({
                  fillColor: this.getColor(layer.feature.properties.name),
                });
              }

              layer.bindTooltip('<div style=\'background:white; padding:1px 3px 1px 3px\'><b>' + layer.feature.properties.name + '</b></div>',
{
    direction: 'right',
    permanent: false,
    sticky: true,
    offset: [10, 0],
    opacity: 0.75,
    className: 'leaflet-tooltip-own'
});
             }
        });



    heatmap.fitBounds(stateLayer.getBounds());
    this.HEATMAP = heatmap;
  }

  getColor(countryName: string): string {
    if (countryName.includes('Ethiopia')){
      return '#00855A';
    }
    if (countryName.includes('Kenya')){
      return '#FED766';
    }
    if (countryName.includes('India')){
      return '#4682B4';
    }
    return '#d62728';
  }

  highlightFeature(e: any): void {
    const layer = e.target;

    layer.setStyle({
        weight: 5,
        color: '#666',
        dashArray: '',
        fillOpacity: 0.7
    });

    layer.bringToFront();
  }

  resetHighlight(e: any): void {
    this.geoJson.resetStyle(e.target);
  }

  onEachFeature(feature: any, layer: any): void {
    layer.on({
        mouseover: this.highlightFeature(layer),
        mouseout: this.resetHighlight(layer),
    });
  }

}
